/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Timing_Info_LabelInputs */

const en_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing Information`)
};

const fr_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations de synchronisation`)
};

const de_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitinformationen`)
};

const it_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni sui tempi`)
};

const ru_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация о времени`)
};

const es_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información de tiempo`)
};

const zh_cn2_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间信息`)
};

const ja_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミング情報`)
};

const hi_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय संबंधी जानकारी`)
};

const pt_pt2_summary_timing_info_label = /** @type {(inputs: Summary_Timing_Info_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações sobre o tempo`)
};

/**
* | output |
* | --- |
* | "Timing Information" |
*
* @param {Summary_Timing_Info_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_timing_info_label = /** @type {((inputs?: Summary_Timing_Info_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Timing_Info_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_summary_timing_info_label(inputs)
	if (locale === "de") return de_summary_timing_info_label(inputs)
	if (locale === "it") return it_summary_timing_info_label(inputs)
	if (locale === "ru") return ru_summary_timing_info_label(inputs)
	if (locale === "es") return es_summary_timing_info_label(inputs)
	if (locale === "zh-CN") return zh_cn2_summary_timing_info_label(inputs)
	if (locale === "ja") return ja_summary_timing_info_label(inputs)
	if (locale === "hi") return hi_summary_timing_info_label(inputs)
	if (locale === "pt-PT") return pt_pt2_summary_timing_info_label(inputs)
	return en_summary_timing_info_label(inputs)
});